import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	holidaysHeader: {
		id: 'servicedesk-sla-settings.calendars.calendar.holidays.holidays-header',
		defaultMessage: 'Holidays',
		description: 'header for holidays section',
	},
	every: {
		id: 'servicedesk-sla-settings.calendars.calendar.holidays.every',
		defaultMessage: 'Every',
		description: 'Message for if holiday is recurring',
	},
	oneTime: {
		id: 'servicedesk-sla-settings.calendars.calendar.holidays.one-time',
		defaultMessage: 'One time',
		description: 'Frequency for if holiday is non recurring',
	},
	annually: {
		id: 'servicedesk-sla-settings.calendars.calendar.holidays.annually',
		defaultMessage: 'Annually',
		description: 'Frequency for if holiday is recurring',
	},
	name: {
		id: 'servicedesk-sla-settings.calendars.calendar.holidays.name',
		defaultMessage: 'Name',
		description: 'Header for name column',
	},
	date: {
		id: 'servicedesk-sla-settings.calendars.calendar.holidays.date',
		defaultMessage: 'Date',
		description: 'Header for date column',
	},
	frequency: {
		id: 'servicedesk-sla-settings.calendars.calendar.holidays.frequency',
		defaultMessage: 'Frequency',
		description: 'Header for frequency column',
	},
});
